/*jshint esversion: 9 */
/*jshint sub:true*/
import { mapGetters, mapActions } from 'vuex';
import WaggonInfoHeader from '@/components/ProjectTaktPlan/WaggonInfoHeader.component.vue';
import WaggonInfoBody from '@/components/ProjectTaktPlan/WaggonInfoBody.component.vue';
import WaggonInfoBodyAdd from '@/components/ProjectTaktPlan/WaggonInfoBodyAdd.component.vue';
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue';
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
import StandardStep from '@/components/StandardComponents/StandardStep.component.vue';
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue';
import TSearchField from '@/components/Taktify/TSearchField.component.vue';

export const WaggonInfoAddMixin = {
  components: {
    WaggonInfoHeader,
    WaggonInfoBody,
    WaggonInfoBodyAdd,
    StandardDataField,
    StandardFlexBox,
    WorkPackage,
    StandardStep,
    StandardBadge,
    TSearchField
  },
  computed: {
    ...mapGetters('Community', [
      'getCommunityWorkPackages',
      'getCommunityWorkPackage',
      'getCWorkPackagesFiltered',
    ]),
    ...mapGetters('WorkPackage', [
      'getWorkPackages',
      'getWorkPackage',
      'getWorkPackagesFiltered',
      'getPagination'
    ]),
    ...mapGetters('WorkBench', [
      'getWBObjects',
      'getWBObjectsFiltered',
    ]),
    ...mapGetters('WorkBenchLocal', [
      'getWBLObject',
    ]),
    workbench_variables() {
      return this.getWBLObject({
        path: [
          {workbench_variables: ''}
        ]
      });
    }
  },
  methods: {
    ...mapActions('Ultra', [
      'createUObject'
    ]),
    ...mapActions('SnackBar', [
      'requestSnackbarCreate'
    ]),
    ...mapActions('TWaggon', [
      'deleteTWaggon',
      'setTWaggons',
      // 'tWorkPackageInsert'
    ]),
    ...mapActions('WorkPackage', [
      'requestCustomWorkPackages'
    ]),
    ...mapActions('WorkBenchLocal', [
      'updateWBLObject',
    ]),
    ...mapActions('WorkBench', [
      'requestWBObject',
      'addLoadAll',
    ]),
    workbenchSearch(val, prefix){
      if (val && val !== '') {
        this.loadData(`&search=${val}`, prefix);
      }
      this.updateWBLObject({
          path: [
            {workbench_variables: ''}
          ],
          update: {
            search: val
          }
        });
    },
    loadData(url_suffix, prefix){
      return new Promise((resolve) => {
        this.updateWBLObject({
          path: [
            {workbench_variables: ''}
          ],
          update: {
            loading: true
          }
        });
        // if (['b', 'c'].includes(this.prefix) || this.isWBObjEmpty('sequences')) {
          this.requestWBObject({
            url: [
              {[`${prefix}workpackages`]: ''},
              {showWithEntitiesNormalized: ''}
            ],
            url_suffix: url_suffix
          }).then(() => {
            this.updateWBLObject({
              path: [
                {workbench_variables: ''}
              ],
              update: {
                loading: false
              }
            });
            resolve();
          });
        // }
      });
    }
  }
};
